<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 標題" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
				
				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="標題" class="mb-0">
							<el-input size="small" v-model="from.title" placeholder="搜索標題"></el-input>
						</el-form-item>
						<el-form-item label="編號" class="mb-0">
							<el-input size="small" v-model="from.notice_no" placeholder="搜索編號"></el-input>
						</el-form-item>
						
						<el-form-item label="已讀狀態" class="mb-0">
								<el-select v-model="from.type" size="small" >
									<el-option label="全部" value="-1"></el-option>
									<el-option label="已讀" value="1"></el-option>
									<el-option label="未讀" value="2"></el-option>
								</el-select>
							</el-form-item>
						
						<el-form-item label="發送時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">

				<el-table-column align="center" width="150" prop="email_no" label="編號">
				</el-table-column>
				
				<el-table-column align="center" width="100" prop="name" label="發送類型">
					<template slot-scope="scope">
						<span  v-if="scope.row.out_type == 1" class="text-warning">
							後台
						</span>
						<span  v-if="scope.row.out_type == 2" class="text-success">
							機構
						</span>
					</template>
				</el-table-column>

				<el-table-column align="center" width="300" prop="name" label="發送人">
					<template slot-scope="scope">
						<span>
							<el-tag v-if="scope.row.out_type == 2" type="success">{{scope.row.ins_data.name}}</el-tag>
							<el-tag v-if="scope.row.out_type == 1" type="warning">Let's GO客服</el-tag>
						</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="title" label="郵件標題">
								<template slot-scope="scope">
									<div v-if="scope.row.title.length > 20">
										{{ scope.row.title.substring(0, 20) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
									</div>
									<div v-else>
										{{ scope.row.title }}
									</div>
								</template>
				</el-table-column>
				
				<el-table-column align="center" width="100" prop="content" label="郵件內容">
						<template slot-scope="scope">
							<div slot="reference" style="cursor: pointer;" class="name-wrapper" @click="openDialog(scope,1)">
								<el-tag size="medium">查看</el-tag>
							</div>
						</template>
				</el-table-column>

				<el-table-column align="center" width="120" prop="reply_content" label="回覆郵件">
						<template slot-scope="scope">
								<div v-if="scope.row.is_reply" slot="reference" style="cursor: pointer;" class="name-wrapper" @click="openDialog(scope,2)">
									<el-tag size="medium">查看</el-tag>
								</div>
								<div v-else slot="reference">
									未回覆
								</div>
						</template>
				</el-table-column>

				<el-table-column align="center"  prop="check_status"  width="80" label="是否已讀">
					<template slot-scope="v">
						<span style="color: red;" v-if="v.row.check_status==0 ">未讀</span>
						<span class="text-success" v-if="v.row.check_status==1 ">已讀</span>
					</template>
				</el-table-column>


				<el-table-column align="center" prop="create_time" width="200" label="發送時間">
				</el-table-column>

                <el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<!-- <el-button v-if="scope.row.is_reply" type="warning" size="mini" plain = disabled>回覆</el-button>
							<el-button v-auth="'edit'+auth_val" v-else size="mini" plain type="warning" @click="openModel(scope)">回覆</el-button> -->
							<el-button v-auth="'edit'+auth_val" size="mini" plain :disabled="scope.row.is_reply ? true : false" type="warning" @click="openModel(scope)">回覆</el-button>
						</el-button-group>
					</template>
				</el-table-column>

			</el-table>
		</div>

		<el-dialog :close-on-click-modal="false" title="添加郵件" :visible.sync="createModelAdd" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單內容 -->
			<el-form :rules="rules" ref="formEdit" :model="addform" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
		
				<el-form-item  label="接收人"  prop="sendtype">
					Let's GO客服
				</el-form-item> 
				
				<el-form-item label="發送標題" prop="reply_title">
					<el-input type="text" v-model="addform.reply_title" 
					placeholder="發送標題" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			
				<el-form-item label="發送內容" prop="reply_content">
					<el-input type="textarea" :rows="8" v-model="addform.reply_content" class="content_huan"
					placeholder="發送內容" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModelAdd = false">取 消</el-button>
				<el-button type="primary" :loading="submitLoading" @click="submitadd">確 定</el-button>
			</div>
		</el-dialog>

		<el-dialog :close-on-click-modal="false"  
			title="回覆消息" 
			:visible.sync="createModel" 
			top="5vh" 
			:width="layout.is_phone ? '90%' : '80%'" 
			class="custom-dialog"
			>
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone ? '80px' : '100px'" :label-position="layout.is_phone ? 'top' : 'left'">
			<template> 
						<el-descriptions v-if="form.out_type == 2" class="margin-top" title="機構信息" :column="2" style="margin-bottom: 30px;" border>
							
                            <el-descriptions-item>
                            <template slot="label">
                                <i class="el-icon-mobile-phone"></i>
                                電話
                            </template>
                            {{ form.ins_phone }}
                            </el-descriptions-item>

							<el-descriptions-item>
                            <template slot="label">
                                <i class="el-icon-message"></i>
                                電郵
                            </template>
                            {{form.ins_email}}
                            </el-descriptions-item>

							<el-descriptions-item>
                            <template slot="label">
                                <i class="el-icon-user"></i>
                                名稱
                            </template>
                            {{ form.ins_name }}
                            </el-descriptions-item>
                            
                            <el-descriptions-item>
                            <template slot="label">
                                <i class="el-icon-position"></i>
                                地址
                            </template>
                            {{form.local}}
                            </el-descriptions-item>

                            <el-descriptions-item>
                            <template slot="label">
                                <i class="el-icon-tickets"></i>
                                簡介
                            </template>
                            {{form.info}}
                            </el-descriptions-item>

					</el-descriptions>


					<el-descriptions class="margin-top" title="郵件信息" :column="3" style="margin: 20px 0;">
						<el-descriptions-item label="编號"> {{ form.email_no }}</el-descriptions-item>
						<el-descriptions-item label="發送人">{{ form.out_type == 2 ? form.ins_name : 'Let\'s Go 客服' }}</el-descriptions-item>
						<el-descriptions-item label="發送時間">
							{{ form.create_time }}
						</el-descriptions-item>
						
						<el-descriptions-item label="標題" :contentStyle="{'width': '80%'}">
							<!-- 限制高度並添加滾動條 -->
							
							{{ form.title }}
							
						</el-descriptions-item>
						<el-descriptions-item label="郵件内容"  :contentStyle="{'width': '90%'}">
							<!-- 限制高度並添加滾動條 -->
							<div class="email-content">
							{{ form.content }}
							</div>
						</el-descriptions-item>
					</el-descriptions>
			</template>
				<!-- 顶部信息展示区 -->
			

				<!-- 回复標題輸入 -->
				<el-form-item label="回覆標題" prop="reply_title">
				<el-input 
					type="text" 
					v-model="form.reply_title"
					maxlength="50"
					show-word-limit
					placeholder="回覆標題"
					clearable 
					size="small" 
					class="form-input"
				/>
				</el-form-item>

				<!-- 回复内容輸入 -->
				<el-form-item label="回覆内容" prop="reply_content">
				<el-input 
					type="textarea" 
					:rows="3" 
					v-model="form.reply_content"
					show-word-limit
					placeholder="回覆内容"
					clearable 
					size="small" 
					class="form-input"
				/>
				</el-form-item>
			</el-form>

			<!-- 底部按钮 -->
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取消</el-button>
				<el-button type="primary" :loading="submitLoading" @click="submit">確定</el-button>
			</div>
		</el-dialog>


		<el-dialog :close-on-click-modal="false"  
			:visible.sync="dialogVisible" 
			:width="layout.is_phone ? '90%' : '70%'" 
			title="郵箱信息" 
			@close="closeDialog"
			>
			<!-- 郵件信息头部 -->
			<div v-if="dialogType == 1" class="dialog-header">
				<div class="email-info">
				<p><strong>標題：</strong> {{ emailTitle }}</p>
				<p><strong v-if="is_reply == 1">發送人：</strong><strong v-if="is_reply == 2">回覆人：</strong> {{ senderName }}</p>
				<p><strong>發送時間：</strong> {{ sendTime }}</p>
				</div>
			</div>
			
			
			<!-- 郵件内容 -->
			<div v-html="dialogContent" class="dialog-content"></div>
			
			<!-- 弹框底部 -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeDialog">關 閉</el-button>
			</span>
		</el-dialog>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>
		<el-dialog :close-on-click-modal="false"  :visible.sync="dialogTitleVisible" title="發送標題">
			<p>{{ fullTitle }}</p>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModelAdd: false,

				
				dialogTitleVisible: false,
				submitLoading: false,
				fullTitle: '',
				is_reply: 1,
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					title: '',
					notice_no: '',
					content:'',
					type:'-1',
					status:'-1',
					uid:'',
					time: [],
				},
				model_title: 'Notice',
				auth_val: 'Notice',
				preUrl: "data/receiveUserEmailList", //列表地址
				addUrl: "data/replyUserEmail", //回覆郵件
                editStatusUrl: "data/editStatusEmail", //修改狀態地址

				tableData: [],
				form: {
					id: 0,
					title:'',
					content:"",
				},
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],
				addform:{},
				school_list: [],
				inst_list: [],
				user_list: [],
				replyData: [],
				
				dialogVisible: false,      // 控制對話框顯示
				dialogContent: '' ,         // 存储當前对话框的内容

				emailTitle: '' ,         // 
				senderName: '' ,         // 
				sendTime: '' ,         // 
				dialogType:1,
				rules: {
					reply_content: [{
							required: true,
							message: "內容不能為空",
							trigger: 'blur',
						},
					],
					reply_title: [{
							required: true,
							message: "標題不能為空",
							trigger: 'blur',
						},
					],
				},
				

			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		
		methods: {
			reply(e){
				
				// 初始化表單數據
				this.form = {
					id: e.row.id,
					out_id: e.row.out_id,
					out_type: e.row.out_type,

                    ins_name: e.row.ins_data.name,
                    ins_phone: e.row.ins_data.phone,
                    local: e.row.ins_data.local,
                    info: e.row.ins_data.info,
                    ins_email: e.row.ins_data.email,

					title: e.row.reply_title,
					email_no: e.row.reply_no,
					create_time: e.row.reply_time,
					content: e.row.reply_content,
					
					reply_content: '',
					reply_title: 'RE:' + e.row.reply_title,
				};
				
				this.editIndex = e.row.id;
				this.createModel = true;
			},
			 // 顯示完整標題内容
			 showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
			openDialog(e,type) {
				let row = e.row
				if(type == 2){
					this.dialogContent = row.reply_content; // 设置要顯示的 HTML 内容
					this.emailTitle = row.reply_title; // 设置要顯示的 HTML 内容
					this.senderName = row.reply_name; // 设置要顯示的 HTML 内容
					this.sendTime = row.reply_time; // 设置要顯示的 HTML 内容
				}else{
					this.dialogContent = row.content; // 设置要顯示的 HTML 内容
					this.emailTitle = row.title; // 设置要顯示的 HTML 内容
					this.senderName = row.sender_name; // 设置要顯示的 HTML 内容
					this.sendTime = row.create_time; // 设置要顯示的 HTML 内容
					this.emailRead(row)
				}
				
				this.dialogType = 1; // 设置要顯示的 HTML 内容
				this.is_reply = type; // 设置要顯示的 HTML 内容
				this.replyData = e; // 设置要顯示的 HTML 内容
				
				this.dialogVisible = true;    // 顯示对话框
			},
			closeDialog() {
				this.dialogVisible = false;   // 關閉对话框
				this.dialogContent = '';      // 清空内容
				this.dialogTitle = '';      // 清空内容
			},
			emailRead(e){
				if(e.check_status == 0){
					this.axios.post('/admin/data/emailRead', {
						type: 3,
						id:e.id,
					}, {
						token: true,
					}).then(res => {
						this.getList()
						this.layout.getPageNum();
					})
				}
			},
			
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				this.$refs.formEdit.validate(res => {
					if (res) {
						this.submitLoading = true
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			openModelAdd() {
				this.addform = {
					title: '',
					content: '',
					in_id:1,
					in_type:1,
				}
				this.createModelAdd = true;
			},
			submitadd(){
				this.$refs.formEdit.validate(res => {
					if (res) {
						this.submitLoading = true;
						this.axios.post('/admin/data/addEmail', 
							this.addform,
						 {
							token: true,
						}).then(all => {
							if (all.data.code == 1) {
									this.$message({
										message: all.data.msg,
										type: 'success'
									}); // 控制是否顯示成功提示
								
								this.createModelAdd = false;
								this.submitLoading = false;
							}else{
								this.submitLoading = false;
							}
							
						}).catch(err => {
							// 失敗
							this.submitLoading = false;
						})
					}
				})
			},
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				// if (!isJPG) {
				//   this.$message.error('上傳头像图片只能是 JPG 格式!');
				// }
				// if (!isLt2M) {
				//   this.$message.error('上傳头像图片大小不能超過 2MB!');
				// }
				return isJPG && isLt2M;
			  },
			

			// 打开模态框
			openModel(e) {
				// 初始化表單數據
				this.form = {
					id: e.row.id,
					out_type: e.row.out_type,
					reply_type: 2,

					ins_name: e.row.ins_data.name,
                    ins_phone: e.row.ins_data.phone,
                    local: e.row.ins_data.local,
                    info: e.row.ins_data.info,
                    ins_email: e.row.ins_data.email,

					title: e.row.title,
					email_no: e.row.email_no,
					create_time: e.row.create_time,
					content: e.row.content,
					
					reply_content: '',
					reply_title: 'RE:' + e.row.title,
				};

				this.editIndex = e.row.id;
				this.createModel = true;
				
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					title: '',
					notice_no: '',
					content:'',
					type:'-1',
					status:'-1',
					uid:'',
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.dialog-header {
  border-bottom: 1px solid #ebeef5;
  padding: 10px 20px;
  margin-bottom: 15px;
}

.email-info p {
  margin: 0;
  font-size: 14px;
  color: #606266;
}

.dialog-content {
  padding: 10px 20px;
}
/* 对话框整体样式 */
.custom-dialog {
  border-radius: 8px; /* 圆角边框 */
  overflow: hidden; /* 防止溢出 */
}

/* 顶部信息样式 */
.dialog-header {
  padding: 15px 20px;
  background-color: #f5f7fa; /* 添加背景色 */
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 15px;
}

.email-info p {
  margin: 0;
  color: #606266;
  font-size: 14px;
  line-height: 1.6;
}

/* 輸入框样式 */
.form-input {
  width: 100%;
  margin-bottom: 10px;
}

/* 底部按钮样式 */
.dialog-footer {
  padding: 10px 20px;
  text-align: right;
}

.dialog-footer .el-button:first-child {
  margin-right: 10px;
}

/* 改进按钮样式 */
.el-button--primary {
  background-color: #409eff;
  border-color: #409eff;
  color: #fff;
}
.el-button--primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

/* 限制郵件内容高度並添加滾動條 */
.email-content {
  max-height: 100px; /* 限制高度 */
  overflow-y: auto; /* 添加垂直滾動條 */
  word-break: break-word; /* 避免內容溢出 */
  padding: 5px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #f9f9f9;
}
</style>
